<template>
  <wrld-container :breadcrumbs="this.breadcrumbs">
    <!-- Upload Orders -->
    <v-container class="align" >
      <v-row>
        <v-col cols="6" sm="6">
          <v-card
          class="mt-5"
          flat
          >
            <!-- <v-card-title primary-title class="mb-5">
              <div class="headline">Upload</div>
            </v-card-title> -->
            <v-card-text class="mb-5">
              <v-row>
                 <v-form v-model="isValid">
                  <v-col cols="12" class="mb-2">
                    <v-input>
                      <v-text-field
                      :disabled="true"
                      :rules="[(value) => !!value || 'Required.']"
                      :value="uploadedFile != null ? uploadedFile.name : $t('uploads.no_file_selected')"
                      >
                      </v-text-field>
                      <v-btn
                        color="accent"
                        @click="handlePickUploadFile"
                        >
                          {{ uploadedFile != null ? $t('uploads.change_file') : $t('uploads.choose_file') }}
                      </v-btn>
                    </v-input>
                    <input
                    type="file"
                    style="display: none"
                    ref="fileUploadInputRef"
                    @change="handleOnFilePicked"/>
                  </v-col>
                  <v-col cols="12"
                    v-show="uploadResourceTypes != null"
                  >
                    <v-select
                      color="wrld_subtitle"
                      v-model="fileResourceType"
                      :items="uploadResourceTypes"
                      :item-text="(item) => ($t(`uploads.${item.text.toLowerCase()}`))"
                      :label="fileResourceType != null ? $t('uploads.file_content') : null"
                      :placeholder="$t('uploads.file_content')"
                    ></v-select>
                  </v-col>
                </v-form>
              </v-row>
            </v-card-text>
            <v-alert type='error' v-if="checkErrors.length > 0">
              <ul>
                <li v-for="error in checkErrors" :key="error.index">
                  {{error}}
                </li>
              </ul>
            </v-alert>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="accent"
                  v-if="!isUploading"
                  :disabled="!(uploadedFile != null && fileResourceType !=null)"
                  @click="handleChecks"
                >
                {{$t('uploads.upload')}}
                </v-btn>
                <v-btn
                  color="accent"
                  v-else
                  :disabled="true"
                >
                  <v-progress-circular
                  size="20"
                  width="3"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-col>
        <v-col
          cols="6"
          class="mt-5"
        >
          <ListUploadedFiles />
        </v-col>
        <v-col
        cols="12"
        >
          <OptimizationButton />
        </v-col>
     </v-row>
    </v-container>
  </wrld-container>
</template>

<script>
import { mapActions } from 'vuex'
import { vehicleService, uploadService, dropService, locationService } from '@/_services'
import * as Papa from 'papaparse'
import moment from 'moment-timezone'
// TODO to be removed
import OptimizationButton from '@/components/wrld/generic/OptimizationButton'
import ListUploadedFiles from '@/components/wrld/generic/ListUploadedFiles'
export default {
  name: 'Upload',
  components: {
    OptimizationButton,
    ListUploadedFiles
  },
  data () {
    return {
      isValid: false,
      uploadedFile: null,
      fileResourceType: null,
      isUploading: false,
      headerName: true,
      rowNumber: true,
      locationType: true,
      refIndexNumber: true,
      noNegatives: true,
      validDate: true,
      validTimeZone: true,
      statusType: [],
      locationTypeArray: ['HQ', 'Office', 'Warehouse', 'Factory', 'Construction', 'Depot'],
      validStatus: true,
      unitsSameDropLength: true,
      originRef: true,
      destinationRef: true,
      validIncoterms: true,
      validLabels: true,
      samePickupBefore: true,
      samePickupAfter: true,
      sameDeliveryBefore: true,
      sameDeliveryAfter: true,
      differentUnitRef: true,
      includedHq: true,
      headerLength: true,
      count: 0,
      checkErrors: [],
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.t('general.upload'), disabled: true }
      ],
      hideContent: false,
      vehicleData: null,
      uploadResourceTypes: null,
    }
  },
  mounted() {
    this.uploadResourceTypes = []
    uploadService.getUploadResourceTypeEnum().then((response) => {
      response.forEach(({ name }) => {
        this.uploadResourceTypes.push({
          text: name,
          value: name
        })
      })
    }).catch((error) => {
      console.error(error)
    })
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar',
      refreshListUploadedFiles: 'uploads/refreshListUploadedFiles'
    }),
    handlePickUploadFile () {
      this.$refs.fileUploadInputRef.click()
    },
    handleOnFilePicked (evt) {
      this.uploadedFile = evt.target.files[0]
      this.checkErrors = []
    },
    getStatus() {
      return dropService.getUnitStatusEnum()
    },
    getLocationType() {
      return locationService.getLocationTypeEnum()
    },
    async handleChecks () {
      this.statusType = []
      this.refIndexNumber = true
      this.noNegatives = true
      this.validDate = true
      this.validTimeZone = true
      this.originRef = true
      this.destinationRef = true
      this.validIncoterms = true
      this.validLabels = true
      this.samePickupBefore = true
      this.samePickupAfter = true
      this.sameDeliveryBefore = true
      this.sameDeliveryAfter = true
      this.differentUnitRef = true
      this.locationType = true
      this.headerName = true
      this.headerLength = true
      this.numberHQ = true
      this.validStatus = true
      this.rowNumber = true
      this.unitsSameDropLength = true
      this.checkErrors = []
      // get status and location data
      const data = await Promise.all([this.getStatus(), this.getLocationType()]).then((response) => {
        response[0].forEach((item) => {
        this.statusType.push(...Object.values(item))
        this.statusType = this.statusType.filter(item => !item.startsWith('__'))
        })
        response[1].forEach((item) => {
        this.locationTypeArray.push(...Object.values(item))
        this.locationTypeArray = this.locationTypeArray.filter(item => !item.startsWith('__'))
        })
      })
      this.validStatus = true
      this.locationType = true

      let file = this.uploadedFile
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: ((results, file) => {
          // console.log('test', results, file)
          let parsedFile = results.data
           if (this.fileResourceType === 'LOCATIONS') {
             let orgRefNum =  parsedFile[0].indexOf('orgRef')
             this.checkErrors = []
            // test number of rows
            this.checkRowNumber(parsedFile)
            // test the headers
            this.checkHeaders(parsedFile)
            // test header length
            this.checkHeaderLength(parsedFile)
            // test location types
            for (let i = 1; i < parsedFile.length; i++) {
              this.checkLocationTypes(parsedFile, i)
            }
            // group based on organization ref number
            let groupOrgRefObject = {}
            let checkLocType = parsedFile[0].indexOf('locType')
            for (let i = 1; i < parsedFile.length; i++) {
              if (groupOrgRefObject[parsedFile[i][orgRefNum]] != null) {
                groupOrgRefObject[parsedFile[i][orgRefNum]].push(parsedFile[i][checkLocType])
                groupOrgRefObject[parsedFile[i][orgRefNum]].push(parsedFile[i][orgRefNum])
              } else {
                groupOrgRefObject[parsedFile[i][orgRefNum]] = []
                groupOrgRefObject[parsedFile[i][orgRefNum]].push(parsedFile[i][checkLocType])
                groupOrgRefObject[parsedFile[i][orgRefNum]].push(parsedFile[i][orgRefNum])
              }
            }
            this.checkLocTypeSameOrg(groupOrgRefObject)
            if (this.rowNumber === true && this.headerName === true && this.locationType === true && this.numberHQ === true && this.headerLength === true) {
             this.handleSubmitUploadFile()
            }
           } else if (this.fileResourceType === 'UNITS') {
             this.checkErrors = []
            //check row number
            this.checkRowNumber(parsedFile)
            // first find the index of each one in the headers
            // then add the check
            let transportRefIndex = parsedFile[0].indexOf('transportRef')
            let originRefIndex = parsedFile[0].indexOf('originRef')
            let destinationRefIndex = parsedFile[0].indexOf('destinationRef')
            let incoterms = parsedFile[0].indexOf('incoterms')
            let labels = parsedFile[0].indexOf('shipmentLabels')
            let unitRefIndex = parsedFile[0].indexOf('unitReference')

            let pickupAfterYear = parsedFile[0].indexOf('pickupAfterYear')
            let pickupAfterMonth = parsedFile[0].indexOf('pickupAfterMonth')
            let pickupAfterDay = parsedFile[0].indexOf('pickupAfterDay')
            let pickupAfterHour = parsedFile[0].indexOf('pickupAfterHour')
            let pickupAfterMinute = parsedFile[0].indexOf('pickupAfterMinute')

            let pickupBeforeYear = parsedFile[0].indexOf('pickupBeforeYear')
            let pickupBeforeMonth = parsedFile[0].indexOf('pickupBeforeMonth')
            let pickupBeforeDay = parsedFile[0].indexOf('pickupBeforeDay')
            let pickupBeforeHour = parsedFile[0].indexOf('pickupBeforeHour')
            let pickupBeforeMinute = parsedFile[0].indexOf('pickupBeforeMinute')

            let deliveryAfterYear = parsedFile[0].indexOf('deliveryAfterYear')
            let deliveryAfterMonth = parsedFile[0].indexOf('deliveryAfterMonth')
            let deliveryAfterDay = parsedFile[0].indexOf('deliveryAfterDay')
            let deliveryAfterHour = parsedFile[0].indexOf('deliveryAfterHour')
            let deliveryAfterMinute = parsedFile[0].indexOf('deliveryAfterMinute')

            let deliveryBeforeYear = parsedFile[0].indexOf('deliveryBeforeYear')
            let deliveryBeforeMonth = parsedFile[0].indexOf('deliveryBeforeMonth')
            let deliveryBeforeDay = parsedFile[0].indexOf('deliveryBeforeDay')
            let deliveryBeforeHour = parsedFile[0].indexOf('deliveryBeforeHour')
            let deliveryBeforeMinute = parsedFile[0].indexOf('deliveryBeforeMinute')

            for (let i = 1; i < parsedFile.length; i++) {
              let dateFormat = 'YYYY/MM/DD, h:mm'
              let datePickupBefore = moment([parsedFile[i][pickupBeforeYear], parsedFile[i][pickupBeforeMonth], parsedFile[i][pickupBeforeDay],
                                    parsedFile[i][pickupBeforeHour], parsedFile[i][pickupBeforeMinute]], dateFormat)
              let datePickupAfter = moment([parsedFile[i][pickupAfterYear], parsedFile[i][pickupAfterMonth], parsedFile[i][pickupAfterDay],
                                    parsedFile[i][pickupAfterHour], parsedFile[i][pickupAfterMinute]], dateFormat)
              let dateDeliveryBefore = moment([parsedFile[i][deliveryBeforeYear], parsedFile[i][deliveryBeforeMonth], parsedFile[i][deliveryBeforeDay],
                                      parsedFile[i][deliveryBeforeHour], parsedFile[i][deliveryBeforeMinute]], dateFormat)
              let dateDeliveryAfter = moment([parsedFile[i][deliveryAfterYear], parsedFile[i][deliveryAfterMonth], parsedFile[i][deliveryAfterDay],
                                      parsedFile[i][deliveryAfterHour], parsedFile[i][deliveryAfterMinute]], dateFormat)
              // check origin, destination, transport and unit ref not empty
              this.checkOriginRef (parsedFile, i)
              // check no negative weight and dimensions
              this.checkNoNegatives(parsedFile, i)
              //check status from GQL enum
              this.checkStatus(parsedFile, i)
              //check dates
              this.checkValidDate(datePickupBefore, datePickupAfter, dateDeliveryBefore, dateDeliveryAfter, i)
              // check timezone
              this.checkValidTimezone(parsedFile, i)
            }

            let groupTransportRefObject = {}
            for (let i = 1; i < parsedFile.length; i++) {
              if (groupTransportRefObject[parsedFile[i][transportRefIndex]] != null) {
                groupTransportRefObject[parsedFile[i][transportRefIndex]].push(parsedFile[i])
              } else {
                groupTransportRefObject[parsedFile[i][transportRefIndex]] = []
                groupTransportRefObject[parsedFile[i][transportRefIndex]].push(parsedFile[i])
              }
            }
            this.checkUnitRow(groupTransportRefObject)
            this.checkUnitsOrigin(groupTransportRefObject, originRefIndex, transportRefIndex)
            this.checkUnitsDestination(groupTransportRefObject, destinationRefIndex, transportRefIndex)
            this.checkUnitsIncoterms(groupTransportRefObject, incoterms, transportRefIndex)
            this.checkUnitsLabels(groupTransportRefObject, labels, transportRefIndex)
            this.checkunitsPickupAfter(groupTransportRefObject, pickupAfterYear, pickupAfterMonth, pickupAfterDay, pickupAfterHour, pickupAfterMinute, transportRefIndex)
            this.checkUnitsPickupBefore(groupTransportRefObject, pickupBeforeYear, pickupBeforeMonth, pickupBeforeDay, pickupBeforeHour, pickupBeforeMinute, transportRefIndex)
            this.checkUnitsDeliveryAfter(groupTransportRefObject, deliveryAfterYear, deliveryAfterMonth, deliveryAfterDay, deliveryAfterHour, deliveryAfterMinute, transportRefIndex)
            this.checkUnitsDeliveryBefore(groupTransportRefObject, deliveryBeforeYear, deliveryBeforeMonth, deliveryBeforeDay, deliveryBeforeHour, deliveryBeforeMinute, transportRefIndex)
            this.checkUnitsRef(groupTransportRefObject, unitRefIndex, transportRefIndex)

            if (this.rowNumber === true && this.refIndexNumber === true &&
              this.noNegatives === true && this.validStatus === true && this.validDate === true &&
              this.validTimeZone === true && this.unitsSameDropLength === true && this.originRef === true &&
              this.destinationRef === true && this.validIncoterms === true && this.validLabels === true &&
              this.samePickupBefore === true && this.samePickupAfter === true && this.sameDeliveryBefore === true &&
              this.sameDeliveryAfter === true && this.differentUnitRef === true) {
            this.handleSubmitUploadFile()
            }
          }
        })
      })
    },
    checkRowNumber (parsedFile) {
      if (parsedFile.length > 1000) {
        this.rowNumber = false
        this.checkErrors.push(this.$t('uploads.column_number'))
      }
    },
    checkUnitRow (groupTransportRefObject) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1000) {
          this.unitsSameDropLength = false
          this.checkErrors.push(this.$t('uploads.units_limit'))
        }
      })
    },
    checkHeaders (parsedFile) {
      if (parsedFile[0].includes('orgRef') && parsedFile[0].includes('orgName') &&
          parsedFile[0].includes('vatNo') && parsedFile[0].includes('regNo') &&
          parsedFile[0].includes('locRef') && parsedFile[0].includes('locType') &&
          parsedFile[0].includes('address') && parsedFile[0].includes('locName')) {
         this.headerName = true
      } else {
        this.headerName = false
        this.checkErrors.push(this.$t('uploads.incorrect_headers'))
      }
    },
    checkHeaderLength (parsedFile) {
      if (parsedFile[0].length > 8) {
        this.headerLength = false
        this.checkErrors.push(this.$t('uploads.incorrect_headers'))
      }
    },
    checkLocationTypes (parsedFile, i) {
      let locType = parsedFile[0].indexOf('locType')
      if (!this.locationTypeArray.includes(parsedFile[i][locType])) {
        this.locationType = false
        this.checkErrors.push(`${this.$t('uploads.location_types_row')} ${i + 1}. ${this.$t('uploads.location_types_include')}.`)
      }
    },
    checkLocTypeSameOrg (groupOrgRefObject) {
      let result
      let objValues = Object.values(groupOrgRefObject)
      objValues.forEach((value) => {
        result = value.filter(type => type === 'HQ')
        if (result.length !== 1) {
          this.numberHQ = false
          this.checkErrors.push(`${this.$t('uploads.location_same_org_ref')} ${value[1]}. ${this.$t('uploads.location_same_org')}.`)
        }
      })
    },
    checkOriginRef (parsedFile, i) {
      let originRefIndex = parsedFile[0].indexOf('originRef')
      let destinationRefIndex = parsedFile[0].indexOf('destinationRef')
      let transportRefIndex = parsedFile[0].indexOf('transportRef')
      let unitRefIndex = parsedFile[0].indexOf('unitReference')
      if (parsedFile[i][originRefIndex] === '' || parsedFile[i][destinationRefIndex] === '' || parsedFile[i][transportRefIndex] === '' || parsedFile[i][unitRefIndex] === '') {
        this.refIndexNumber = false
        this.checkErrors.push(`${this.$t('uploads.please_check_row')} ${i + 1}. ${this.$t('uploads.ref_not_empty')}.`)
      }
    },
    checkNoNegatives (parsedFile, i) {
      let unitWeightIndex = parsedFile[0].indexOf('unitWeight')
      let unitLengthIndex = parsedFile[0].indexOf('unitLength')
      let unitHeightIndex = parsedFile[0].indexOf('unitHeight')
      let unitWidthIndex = parsedFile[0].indexOf('unitWidth')
      let itemWeightIndex = parsedFile[0].indexOf('itemWeight')
      if (parsedFile[i][unitWeightIndex] < 0 || parsedFile[i][unitLengthIndex] < 0 || parsedFile[i][unitHeightIndex] < 0 || parsedFile[i][unitWidthIndex] < 0 || parsedFile[i][itemWeightIndex] < 0) {
        this.noNegatives = false
        this.checkErrors.push(`${this.$t('uploads.please_check_row')} ${i + 1}. ${this.$t('uploads.no_negative_values')}.`)
      }
    },
    checkStatus (parsedFile, i) {
      let unitStatus = parsedFile[0].indexOf('unitStatus')
      if (!this.statusType.includes(parsedFile[i][unitStatus])) {
        this.validStatus = false
        this.checkErrors.push(`${this.$t('uploads.please_check_row')} ${i + 1}. ${this.$t('uploads.unit_status')}.`)
      }
    },
    checkValidDate (datePickupBefore, datePickupAfter, dateDeliveryBefore, dateDeliveryAfter, i) {
      if (datePickupBefore.isValid() === false || datePickupAfter.isValid() === false ||
          dateDeliveryBefore.isValid() === false || dateDeliveryAfter.isValid() === false) {
          this.validDate = false
          this.checkErrors.push(`${this.$t('uploads.please_check_row')} ${i + 1}. ${this.$t('uploads.date')}.`)
      }
    },
    checkValidTimezone (parsedFile, i) {
      let pickupBeforeTZ = parsedFile[0].indexOf('pickupBeforeTZ')
      let deliveryBeforeTZ = parsedFile[0].indexOf('deliveryBeforeTZ')
      let tmzPickup = moment.tz.zone(parsedFile[i][pickupBeforeTZ])
      let tmzDelivery = moment.tz.zone(parsedFile[i][deliveryBeforeTZ])
      if (tmzPickup === null || tmzDelivery === null) {
        this.validTimeZone = false
        this.checkErrors.push(`${this.$t('uploads.please_check_row')} ${i + 1}. ${this.$t('uploads.timezone')}.`)
      }
    },
    checkUnitsOrigin (groupTransportRefObject, originRefIndex, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][originRefIndex] !== value [i+1][originRefIndex]) {
              this.originRef = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.units_same_origin')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    checkUnitsDestination (groupTransportRefObject, destinationRefIndex, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][destinationRefIndex] !== value [i+1][destinationRefIndex]) {
              this.destinationRef = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.units_same_destination')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    checkUnitsIncoterms (groupTransportRefObject, incoterms, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][incoterms] !== value [i+1][incoterms]) {
              this.validIncoterms = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.units_same_incoterms')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    checkUnitsLabels (groupTransportRefObject, labels, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][labels] !== value [i+1][labels]) {
              this.validLabels = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.units_same_labels')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    checkunitsPickupAfter (groupTransportRefObject, pickupAfterYear, pickupAfterMonth, pickupAfterDay, pickupAfterHour, pickupAfterMinute, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][pickupAfterYear] !== value[i + 1][pickupAfterYear] || value[i][pickupAfterMonth] !== value[i + 1][pickupAfterMonth] ||
                value[i][pickupAfterDay] !== value[i + 1][pickupAfterDay] || value[i][pickupAfterHour] !== value[i + 1][pickupAfterHour] ||
                value[i][pickupAfterMinute] !== value[i + 1][pickupAfterMinute]) {
              this.samePickupAfter = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.units_same_pickup_after')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    checkUnitsPickupBefore (groupTransportRefObject, pickupBeforeYear, pickupBeforeMonth, pickupBeforeDay, pickupBeforeHour, pickupBeforeMinute, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][pickupBeforeYear] !== value[i + 1][pickupBeforeYear] || value[i][pickupBeforeMonth] !== value[i + 1][pickupBeforeMonth] ||
                value[i][pickupBeforeDay] !== value[i + 1][pickupBeforeDay] || value[i][pickupBeforeHour] !== value[i + 1][pickupBeforeHour] ||
                value[i][pickupBeforeMinute] !== value[i + 1][pickupBeforeMinute]) {
              this.samePickupBefore = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.units_same_pickup_before')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    checkUnitsDeliveryAfter (groupTransportRefObject, deliveryAfterYear, deliveryAfterMonth, deliveryAfterDay, deliveryAfterHour, deliveryAfterMinute, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][deliveryAfterYear] !== value[i + 1][deliveryAfterYear] || value[i][deliveryAfterMonth] !== value[i + 1][deliveryAfterMonth] ||
                value[i][deliveryAfterDay] !== value[i + 1][deliveryAfterDay] || value[i][deliveryAfterHour] !== value[i + 1][deliveryAfterHour] ||
                value[i][deliveryAfterMinute] !== value[i + 1][deliveryAfterMinute]) {
              this.sameDeliveryAfter = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.units_same_delivery_after')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    checkUnitsDeliveryBefore (groupTransportRefObject, deliveryBeforeYear, deliveryBeforeMonth, deliveryBeforeDay, deliveryBeforeHour, deliveryBeforeMinute, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][deliveryBeforeYear] !== value[i + 1][deliveryBeforeYear] || value[i][deliveryBeforeMonth] !== value[i + 1][deliveryBeforeMonth] ||
                value[i][deliveryBeforeDay] !== value[i + 1][deliveryBeforeDay] || value[i][deliveryBeforeHour] !== value[i + 1][deliveryBeforeHour] ||
                value[i][deliveryBeforeMinute] !== value[i + 1][deliveryBeforeMinute]) {
              this.sameDeliveryBefore = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.units_same_delivery_before')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    checkUnitsRef (groupTransportRefObject, unitRefIndex, transportRefIndex) {
      let objValues = Object.values(groupTransportRefObject)
      objValues.forEach((value) => {
        if (value.length > 1) {
          for(let i = 0; i < value.length - 1; i++) {
            if (value[i][unitRefIndex] === value [i+1][unitRefIndex]) {
              this.differentUnitRef = false
              let errorMessage = `${this.$t('uploads.check_transport')} ${value[1][transportRefIndex]}. ${this.$t('uploads.unique_ref')}.`
              // checks if the error message already exists in the error array
              // so we don't have same error messages with same transport ref numbers
              this.checkErrors.indexOf(errorMessage) === -1 ? this.checkErrors.push(errorMessage) : console.log('exists')
            }
          }
        }
      })
    },
    handleSubmitUploadFile () {
      // console.log('upload')
      this.isUploading = true
      uploadService.uploadFile({ file: this.uploadedFile, resource: this.fileResourceType }).then((response) => {
        this.showSnackbar({ message: this.$t('snackbars.data_uploaded'), color: 'success' })
      }).catch((error) => {
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        console.error(error)
      }).finally(() => {
        this.refreshListUploadedFiles({ limit: 20 })
        this.isUploading = false
      })
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
  ::v-deep .form-check {
    position: relative;
    display: block;
  }
  ::v-deep .form-group {
    margin-bottom: 1rem;
  }
  ::v-deep .form-check-label {
    margin-bottom: 0;
  }
  ::v-deep .submitBtn {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    color: #fff;
    background-color: #267885;
    border-color: #267885;
  }
    ::v-deep .uploadBtn {
    // display: block;
    // margin: 0 auto;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    color: #fff;
    background-color: #267885;
    border-color: #267885;
  }
  ::v-deep .table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;

    td, th {
      padding: .75rem;
      vertical-align: top;
      border-top: 1px solid #dee2e6;
    }

    thead th {
      vertical-align: bottom;
      border-bottom: 2px solid #dee2e6;
    }

    .form-control {
      display: block;
      width: 100%;
      height: calc(2.25rem + 2px);
      padding: .375rem .75rem;
      font-size: 1rem;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: .25rem;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
  }
</style>
